import gql from 'graphql-tag'

export default gql`
  mutation saveSearchHistory($input: SaveSearchHistoryInput!) {
    saveSearchHistory(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`
